import React from "react";
import { MdOutlineArrowLeft, MdOutlineArrowRight } from "react-icons/md";
import Logo from "../../../../assets/images/logo/logo-light.png";
import { BotMessageIcon } from "./subComponents";
const Messages = ({
  // Messages
  conversation,
}) => {
  return (
    <>
      {/* Main */}
      <section className="main">
        {!conversation && (
          <div className="empty-chat-container">
            <img src={Logo} width={45} height={45} alt="Copilotly" />
            <h1 style={{ color: "#fff" }}>Copilotly.AI</h1>
            <h3 style={{ color: "#fff" }}>How can I help you today?</h3>
          </div>
        )}

        <div className="main-header">
          <ul>
            {conversation?.map((chatMsg, idx) => {
              const isUser = chatMsg.role === "user";

              return (
                <li key={idx}>
                  {isUser ? (
                    <div
                      className="user-message-container"
                      style={{ marginLeft: "10px" }}
                    >
                      <p className="chatbot-user-message">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: chatMsg.content,
                          }}
                        />
                      </p>
                    </div>
                  ) : (
                    <>
                      <div className="bot-message-container">
                        <div style={{ display: "flex" }}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <BotMessageIcon name={"C"} />
                          </div>
                          <div
                            style={{
                              marginLeft: "10px",
                            }}
                          >
                            <div
                              key={idx}
                              className="chatbot-message"
                              style={{ margin: "5px" }}
                            >
                              {chatMsg.content}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      </section>
    </>
  );
};

export default Messages;
